import { makeStyles } from '@material-ui/core';
import React, { ElementType } from 'react';
import ReactLinkify from 'react-linkify';

const useStyles = makeStyles(() => ({
  contentCommentLink: {
    color: '#2563eb',
    textDecoration: 'underline',
    fontWeight: 500,
    wordBreak: 'break-all',
  },
}));

export default function LinkifyText({
  text,
  className = '',
  component: Component = 'span',
}: {
  text: string;
  className?: string;
  component?: ElementType;
}) {
  const classes = useStyles();
  if (!text) {
    return null;
  }

  const componentDecorator = (
    href: string,
    decoratedText: string,
    key: number
  ) => (
    <a
      href={href}
      key={key}
      target="_blank"
      rel="noopener noreferrer"
      className={classes.contentCommentLink}
    >
      {decoratedText}
    </a>
  );

  return (
    <Component className={className}>
      <ReactLinkify componentDecorator={componentDecorator}>
        {text}
      </ReactLinkify>
    </Component>
  );
}
